import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useT, LangToggle } from "../lib/i18n";

export default function ForgotPassword() {
  const t = useT();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(event) {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", {
        email,
        lang: localStorage.getItem("rg_lang") || "en",
      });
      setSubmitted(true);
    } catch {
      setError(t("auth.forgot.error"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#070B14] p-4 sm:p-8">
      <main className="w-full max-w-md grid-card space-y-6 p-6 sm:p-8">
        <div className="flex justify-end"><LangToggle /></div>
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.18em] text-slate-400">{t("auth.recovery.label")}</p>
          <h1 className="mt-2 text-2xl font-bold text-white">{t("auth.forgot.title")}</h1>
          <p className="mt-2 text-sm leading-relaxed text-slate-300">{t("auth.forgot.description")}</p>
        </div>
        {submitted ? (
          <div role="status" className="border border-emerald-500/30 bg-emerald-950/30 p-4 text-sm leading-relaxed text-emerald-100" data-testid="forgot-password-success">
            {t("auth.forgot.success")}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
            <div>
              <label htmlFor="recovery-email" className="text-xs font-semibold uppercase tracking-wide text-slate-400">{t("login.email")}</label>
              <input
                id="recovery-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="mt-1 w-full rounded-sm border border-[#1E2C42] bg-[#0B1321] px-3 py-2 text-white focus:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/20"
                data-testid="forgot-password-email"
              />
            </div>
            {error && <p role="alert" className="border border-red-500/30 bg-red-950/40 px-3 py-2 text-sm text-red-200">{error}</p>}
            <button type="submit" disabled={loading} className="btn-primary w-full py-2.5" data-testid="forgot-password-submit">
              {loading ? t("auth.forgot.sending") : t("auth.forgot.submit")}
            </button>
          </form>
        )}
        <Link to="/login" className="inline-flex text-sm font-semibold text-cyan-400 hover:underline">
          {t("auth.forgot.back")}
        </Link>
      </main>
    </div>
  );
}
